
export interface TableHealthOperatorProps {
  trackingKey?: string;
  data?: Array<any>;
  onPageChange?: any;
  pageSize?: number;
  showPagination?: boolean;
  currentPage?: number;
  error?: boolean;
  onReload?: any;
  setTableOrder?: any;
  tableOrder?: any;
  totalPages?: number;
  total?: number;
  model: Array<ITableModel>;
  className?: string;
  DropdownTemplate?: any;
  customProps?: {
    [key: string]: any;
  };
}

export interface ITableModel {
  label: string;
  key?: string;
  noFilter?: boolean;
  type?: string | "date" | "date/hour" | "currency" | "phone" | "cnpj";
  Component?: (data: any) => JSX.Element | any;
  size?: number;
  maxSize?: number;
  isButton?: boolean;
}

export enum EnumStatusDisabledArrowDown {
  FINISHED = "FINISHED"
}